(function carzillaDesktopCategories() {
  'use strict';
  if (window.carzillaDesktopCategoriesLoaded) return;
  window.carzillaDesktopCategoriesLoaded = true;
  const script = document.currentScript || document.querySelector('script[data-czc-script]');
  if (!script) return;
  const copy = script.dataset;
  const desktop = window.matchMedia('(min-width: 992px)');
  const instances = new Map();
  const normal = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase();
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  const paths = {
    search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
    wash: 'M12 2S5 10 5 15a7 7 0 0 0 14 0c0-5-7-13-7-13Z',
    shield: 'M12 2l8 4v6c0 5-8 10-8 10S4 17 4 12V6l8-4Z',
    wheel: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 9v-6m-3 9H3m9 3v6m3-9h6m-6-2 4-4m-10 4L5 5m4 10-4 4m10-4 4 4M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
    bottle: 'M9 2h6v4H9zM8 9h8l2 3v9H6v-9l2-3ZM10 6v3m4-3v3',
    towel: 'M5 3h14v16H5zM2 6v16h14',
    brush: 'M15 2l7 7-8 8-7-7 8-8ZM7 10l-5 5 7 7 5-5M5 13l7 7M3 15l7 7',
    pad: 'M22 12a10 7 0 1 1-20 0 10 7 0 0 1 20 0ZM2 12v5a10 6 0 0 0 20 0v-5',
    glass: 'M4 3h16v18H4zM7 8l5-3M7 13l10-6M12 15l5-3',
    light: 'M8 3h8v7l-2 3v9h-4v-9l-2-3V3ZM8 6h8M3 4 1 2m20 2 2-2',
    tools: 'M14 3a6 6 0 0 0-7 7L2 15a4 4 0 0 0 6 6l5-5a6 6 0 0 0 8-7l-5 4-5-5 3-5Z',
    seat: 'M8 2h6v7H8zM7 12h9l2 6H5l2-6ZM5 18v4m13-4v4M3 13v5h18v-5',
    wind: 'M2 8h12a3 3 0 1 0-3-3M2 12h17a3 3 0 1 1-3 3M2 18h6',
    spark: 'm12 2 3 7 7 3-7 3-3 7-3-7-7-3 7-3 3-7Z',
    box: 'm3 7 9-5 9 5v11l-9 4-9-4V7Zm0 0 9 5 9-5M12 12v10M7 4l9 5',
    car: 'm4 9 3-5h10l3 5M2 9h20v9H2V9Zm3 9v3m14-3v3M5 13h3m8 0h3',
    polisher: 'm2 14 4-6 9-4 4 4-5 7-5-2-4 5-3-4ZM14 15l3 4h6M5 18l2 3'
  };
  function icon(name) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [key, value] of Object.entries({viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.5','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) svg.setAttribute(key, value);
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', paths[name] || paths.box);
    svg.append(path);
    return svg;
  }
  function groupIcon(name) {
    const value = normal(name);
    for (const [pattern, key] of [[/polisher|compound|polish/, 'polisher'],[/wheel|tire/, 'wheel'],[/protect|ceramic|ppf|trim/, 'shield'],[/wash/, 'wash'],[/brush/, 'brush'],[/towel|fabric|alcantara/, 'towel'],[/glass|window|windshield/, 'glass'],[/odor/, 'wind'],[/leather|interior|dash/, 'seat'],[/pad|plate|applicator/, 'pad'],[/light/, 'light'],[/clean|bottle|foam|decontamination/, 'bottle'],[/convertible|engine|headlight/, 'car'],[/metal|pressure|tool/, 'tools']]) if (pattern.test(value)) return key;
    return 'box';
  }
  const definitions = {
    exterior: {tabs:[['clean', 'clean', /wash|decontamination|general cleaners|engine bay/],['protect', 'protect', /protection|trim|ppf/],['surfaces', 'surfaces', /convertible|headlight|metal|window|wheels/]], popular:['Wash','Wheels & Tire','Protection','Decontamination','General Cleaners','Trim','Window']},
    interior: {tabs:[['clean', 'clean', null, /clean|clnr|apc|degreas|stain|shampoo|disinfect|odor|smoke|waterspot|detailer/],['protect', 'protect', null, /protect|ceramic|condition|waterproof|sealant|anti fog/],['tools', 'accessories', null, /brush|towel|extractor|floormat/]], popular:['Alcantara','Dash & Vinyl','Fabric','General Cleaners','Leather','Odor','Window']},
    'paint correction': {tabs:[['machines','machines',/polisher|backing plate|holders/],['pads','compounds_pads',/compound|pads/],['finish','prep_finish',/cleaning|lighting|glass|metal|plastic|ppf/]], popular:['Polisher','Compound & Polish','Pads','Backing Plate','Cleaning','Lighting','Glass']},
    accessories: {tabs:[['towels','towels_brushes',/towel|brush|applicator/],['wash','wash_tools',/^wash$|bottles|foam gun|grit guard/],['equipment','equipment',/pressure|blower|filtration|tape|misc|apparel/]], popular:['Towel','Brush','Applicator','Bottles','Wash','Pressure Washer','Blowers']},
    'boat & rv': {tabs:[['clean','clean',/general|wash|interior|glass/],['correct','correction',/compound|polish|metal/],['protect','protect',/protection/]], popular:['Wash','Protection','GelCoat Compound & Polish','General Cleaners','Interior','Glass','Metal']},
    'bundle builder': {tabs:[],popular:[]}
  };
  const order = {
    exterior:['Wash','Protection','Convertible Tops','Decontamination','Wheels & Tire','Engine Bay','General Cleaners','Trim','Headlights','Metal','PPF','Window'],
    interior:['Alcantara','Fabric','Odor','Dash & Vinyl','Leather','Window','General Cleaners'],
    'paint correction':['Polisher','Pads','Lighting','Compound & Polish','Backing Plate','Cleaning','Glass','Metal','Plastic','PPF','Holders'],
    accessories:['Towel','Bottles','Pressure Washer','Brush','Wash','Water Filtration','Applicator','Foam Gun','Blowers','Grit Guard','Tape','Misc','Apparel']
  };
  const translate = key => copy[key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())] || '';
  const label = (key, replacements = {}) => Object.entries(replacements).reduce((text, [name, value]) => text.replaceAll('__' + name + '__', String(value)), translate(key));
  class CategoryMenu {
    constructor(item, index) {
      this.item = item;
      this.nav = item.closest('#navigation1');
      this.trigger = item.querySelector(':scope > .mm_parent_link');
      this.panel = item.querySelector(':scope > .megamenu-panel');
      this.source = this.panel?.querySelector(':scope > .megamenu-lists');
      this.name = this.trigger?.querySelector('.mm_parent')?.textContent.trim();
      this.definition = definitions[normal(this.name || '')];
      if (!this.source || !this.definition) return;
      const buttons = Array.from(this.source.querySelectorAll('.mm-parent .mm-list > li > .tablinks'));
      const panels = Array.from(this.source.querySelectorAll('.megamenu_child_desk > .tabvetcontent'));
      const readLink = link => ({name:link.textContent.trim(), href:link.getAttribute('href')});
      this.groups = buttons.map((button, index) => ({name:button.textContent.trim(),links:Array.from(panels[index]?.querySelectorAll('a[href]') || []).map(readLink)}));
      if (!buttons.length) this.groups = Array.from(this.source.querySelectorAll('a[href]')).map(link => ({...readLink(link),links:[]}));
      this.groups = this.groups.filter(group => group.name && (group.links.length || group.href));
      if (!this.groups.length) return;
      const preferredOrder = order[normal(this.name)];
      if (preferredOrder) {
        const rank = group => {const position=preferredOrder.indexOf(group.name);return position<0?preferredOrder.length:position;};
        this.groups.sort((a,b)=>rank(a)-rank(b));
      }
      this.groups.forEach((group, index) => { group.id = index; });
      this.saved = new Map();
      this.controller = new AbortController();
      this.opened = false;
      this.filter = 'all';
      this.selected = null;
      this.expanded = new Set();
      this.id = 'cz-category-directory-' + index;
      this.save(this.trigger, 'aria-expanded', 'false');
      this.save(this.trigger, 'aria-controls', this.id);
      this.save(this.trigger, 'role', 'button');
      this.build();
      this.item.classList.add('cz-desktop-categories');
      this.listen(this.nav, 'click', event => {
        if (event.target.closest('.mm_parent_link') !== this.trigger) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.opened ? this.close() : this.open(event.detail === 0);
      }, true);
      this.listen(this.nav, 'touchstart', event => {
        if (event.target.closest('.mm_parent_link') === this.trigger) event.stopImmediatePropagation();
      }, true);
      this.listen(this.item, 'keydown', event => {
        if (event.key === 'Escape' && this.opened) {
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
        } else if (event.target === this.trigger && [' ', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          this.open(true);
        }
      });
      this.listen(this.item, 'focusout', () => window.setTimeout(() => {
        if (this.opened && !this.item.contains(document.activeElement)) this.close();
      }, 0));
      ['input','search'].forEach(type => this.listen(this.input, type, () => {
        this.filter = 'all';
        this.selected = null;
        this.render();
      }));
      this.listen(this.clear, 'click', () => {this.reset();this.input.focus();});
      this.listen(this.closeButton, 'click', () => this.close(true));
      this.listen(this.filters, 'click', event => {
        const button = event.target.closest('[data-czc-filter]');
        if (!button) return;
        this.filter = button.dataset.czcFilter;
        this.selected = null;
        this.input.value = '';
        this.render();
      });
      this.listen(this.featured, 'click', event => {
        const button = event.target.closest('[data-czc-group]');
        if (!button) return;
        this.selected = Number(button.dataset.czcGroup);
        this.filter = 'all';
        this.input.value = '';
        this.expanded.add(this.selected);
        this.render();
      });
      this.listen(this.scroll, 'click', event => {
        const button = event.target.closest('[data-czc-expand]');
        if (!button) return;
        const id = Number(button.dataset.czcExpand);
        const expanded = !this.expanded.has(id);
        expanded ? this.expanded.add(id) : this.expanded.delete(id);
        button.closest('.czc-group').querySelectorAll('[data-czc-overflow]').forEach(li => {li.hidden = !expanded;});
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? translate('fewer') : label('more', {count:this.groups[id].links.length});
      });
      this.render();
      this.ready = true;
    }
    listen(element, type, listener, capture = false) {
      element.addEventListener(type, listener, {signal:this.controller.signal,capture});
    }
    save(element, name, value) {
      if (!this.saved.has(element)) this.saved.set(element, new Map());
      this.saved.get(element).set(name, element.getAttribute(name));
      element.setAttribute(name, value);
    }
    button(className, text) {
      const button = make('button', className, text);
      button.type = 'button';
      return button;
    }
    build() {
      this.shell = make('div','czc-shell');
      const sidebar = make('aside','czc-sidebar');
      sidebar.setAttribute('aria-label',translate('popular'));
      const search = make('div','czc-search-wrap');
      const searchLabel = make('label','czc-sr-only',label('search',{menu:this.name}));
      searchLabel.htmlFor = this.id + '-search';
      const searchIcon = icon('search');
      searchIcon.classList.add('czc-search-icon');
      this.input = make('input','czc-search');
      this.input.type = 'search';
      this.input.id = searchLabel.htmlFor;
      this.input.placeholder = this.name.length > 13 ? translate('search_hint') : label('search',{menu:this.name});
      this.input.autocomplete = 'off';
      this.input.spellcheck = false;
      this.input.setAttribute('aria-controls',this.id);
      this.clear = this.button('czc-clear','×');
      this.clear.setAttribute('aria-label',translate('clear'));
      search.append(searchLabel,searchIcon,this.input,this.clear);
      this.featured = make('ul','czc-featured');
      const preferred = this.definition.popular.map(name => this.groups.find(group => normal(group.name) === normal(name))).filter(Boolean);
      (preferred.length ? preferred : this.groups.slice(0,8)).forEach(group => {
        const li = make('li');
        const button = group.href ? make('a','czc-shortcut',group.name) : this.button('czc-shortcut',group.name);
        if (group.href) button.href = group.href;
        else {
          button.dataset.czcGroup = group.id;
          button.setAttribute('aria-controls',this.id);
          button.setAttribute('aria-pressed','false');
        }
        const arrow = make('span','czc-chevron');
        arrow.setAttribute('aria-hidden','true');
        button.append(arrow);
        li.append(button);
        this.featured.append(li);
      });
      sidebar.append(search,make('div','czc-kicker',translate('popular')),this.featured);
      const main = make('div','czc-main');
      const heading = make('div','czc-heading');
      this.closeButton = this.button('czc-close','×');
      this.closeButton.setAttribute('aria-label',translate('close'));
      heading.append(make('div','czc-kicker',label('browse',{menu:this.name})),this.closeButton);
      this.filters = make('div','czc-filters');
      this.filters.setAttribute('role','group');
      this.filters.setAttribute('aria-label',translate('filter'));
      [['all','all'],...this.definition.tabs].forEach(([key,copyKey]) => {
        const button = this.button('czc-filter',translate(copyKey));
        button.dataset.czcFilter = key;
        button.setAttribute('aria-controls',this.id);
        button.setAttribute('aria-pressed',String(key === 'all'));
        this.filters.append(button);
      });
      this.status = make('div','czc-status czc-sr-only');
      this.status.setAttribute('role','status');
      this.status.setAttribute('aria-live','polite');
      this.status.setAttribute('aria-atomic','true');
      this.scroll = make('div','czc-scroll');
      this.scroll.id = this.id;
      this.scroll.tabIndex = 0;
      this.scroll.setAttribute('role','region');
      this.scroll.setAttribute('aria-label',label('browse',{menu:this.name}));
      main.append(heading,this.filters,this.status,this.scroll);
      this.shell.append(sidebar,main);
      this.panel.append(this.shell);
    }
    reset() {
      this.input.value = '';
      this.filter = 'all';
      this.selected = null;
      this.render();
    }
    render() {
      const query = normal(this.input.value);
      const definition = this.definition.tabs.find(tab => tab[0] === this.filter);
      const groups = this.groups.flatMap(group => {
        if (this.selected !== null && group.id !== this.selected) return [];
        if (definition?.[2] && !definition[2].test(normal(group.name))) return [];
        const groupMatch = normal(group.name).includes(query);
        const links = group.links.filter(link => (!definition?.[3] || definition[3].test(normal(link.name))) && (!query || groupMatch || normal(link.name).includes(query)));
        if (group.href ? query && !groupMatch : !links.length) return [];
        return [{...group,links}];
      });
      this.clear.hidden = !query;
      this.filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed',String(this.selected === null && button.dataset.czcFilter === this.filter)));
      this.featured.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.czcGroup) === this.selected)));
      const count = groups.reduce((sum,group) => sum + (group.href ? 1 : group.links.length),0);
      this.status.textContent = label('results',{count});
      this.status.classList.toggle('czc-sr-only',!query && this.selected === null);
      const fragment = document.createDocumentFragment();
      if (!groups.length) fragment.append(make('p','czc-empty',translate('empty')));
      else {
        const columns = [0,1,2].map(() => make('div','czc-column'));
        const heights = [0,0,0];
        groups.forEach(group => {
          const expanded = this.expanded.has(group.id) || Boolean(query) || this.selected !== null || this.filter !== 'all';
          const section = make('section','czc-group');
          section.setAttribute('aria-labelledby',this.id + '-group-' + group.id);
          const iconBox = make('span','czc-icon');
          iconBox.append(icon(groupIcon(group.name)));
          const content = make('div','czc-group-content');
          const title = make('h3','czc-title');
          title.id = this.id + '-group-' + group.id;
          if (group.href) {
            const link = make('a','czc-group-link',group.name);
            link.href = group.href;
            title.append(link);
          } else title.textContent = group.name;
          content.append(title);
          if (group.links.length) {
            const list = make('ul','czc-links');
            list.id = title.id + '-links';
            group.links.forEach((link,index) => {
              const li = make('li');
              const anchor = make('a','czc-link',link.name);
              anchor.setAttribute('href',link.href);
              li.append(anchor);
              if (index >= 5) {li.dataset.czcOverflow='';li.hidden=!expanded;}
              list.append(li);
            });
            content.append(list);
            if (group.links.length > 5 && !query && this.selected === null && this.filter === 'all') {
              const button = this.button('czc-more',expanded ? translate('fewer') : label('more',{count:group.links.length}));
              button.dataset.czcExpand = group.id;
              button.setAttribute('aria-expanded',String(expanded));
              button.setAttribute('aria-controls',list.id);
              content.append(button);
            }
          }
          section.append(iconBox,content);
          const column = heights.indexOf(Math.min(...heights));
          columns[column].append(section);
          heights[column] += 3 + (expanded ? group.links.length : Math.min(6,group.links.length));
        });
        const grid = make('div',groups.length === 1 ? 'czc-grid czc-grid-single' : 'czc-grid');
        columns.forEach(column => {if(column.children.length) grid.append(column);});
        fragment.append(grid);
      }
      this.scroll.replaceChildren(fragment);
      this.scroll.scrollTop = 0;
    }
    geometry() {
      const rect = this.nav.getBoundingClientRect();
      const width = Math.min(1540,window.innerWidth-64);
      const height = Math.min(640,Math.max(160,window.innerHeight-rect.bottom-28));
      this.panel.style.setProperty('--czc-width',width+'px');
      this.panel.style.setProperty('--czc-left',((window.innerWidth-width)/2-rect.left)+'px');
      this.panel.style.setProperty('--czc-height',height+'px');
    }
    open(focusSearch = false) {
      if (!desktop.matches) return;
      instances.forEach(instance => {if(instance !== this) instance.close();});
      const navigation = window.jQuery && window.jQuery(this.nav).data('navigation');
      if (navigation) navigation.hideSubmenu(window.jQuery(this.item).siblings('li'),'fade');
      this.geometry();
      this.opened = true;
      this.item.classList.add('cz-categories-open','focus');
      this.trigger.setAttribute('aria-expanded','true');
      if (focusSearch) this.input.focus();
    }
    close(restoreFocus = false) {
      this.opened = false;
      this.item.classList.remove('cz-categories-open','focus');
      this.trigger.setAttribute('aria-expanded','false');
      if (restoreFocus) this.trigger.focus();
    }
    destroy() {
      if (!this.ready) return;
      this.close();
      this.controller.abort();
      this.shell.remove();
      this.item.classList.remove('cz-desktop-categories');
      ['--czc-width','--czc-left','--czc-height'].forEach(name => this.panel.style.removeProperty(name));
      this.saved.forEach((attributes,element) => attributes.forEach((value,name) => value === null ? element.removeAttribute(name) : element.setAttribute(name,value)));
    }
  }
  function init() {
    instances.forEach((instance,item) => {
      if (!desktop.matches || !item.isConnected) {instance.destroy();instances.delete(item);}
    });
    if (!desktop.matches) return;
    document.querySelectorAll('#navigation1 .nav-menu > li:not(.mm_brandlist_container)').forEach((item,index) => {
      if (instances.has(item)) return;
      const instance = new CategoryMenu(item,index);
      if (instance.ready) instances.set(item,instance);
    });
  }
  ['pointerdown','click','keydown'].forEach(type => document.addEventListener(type,event => {
    if (type === 'keydown' && !['Enter',' ','ArrowDown'].includes(event.key)) return;
    instances.forEach(instance => {
      if (instance.opened && !instance.item.contains(event.target)) instance.close();
    });
  },true));
  let frame = 0;
  function geometry() {
    if (frame) return;
    frame = requestAnimationFrame(() => {frame=0;instances.forEach(instance => {if(instance.opened) instance.geometry();});});
  }
  desktop.addEventListener('change',init);
  window.addEventListener('resize',geometry,{passive:true});
  window.addEventListener('scroll',geometry,{passive:true});
  window.addEventListener('pageshow',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event => {
    instances.forEach((instance,item) => {if(event.target.contains(item)){instance.destroy();instances.delete(item);}});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
